export default function DialogBackdrop() {
  return <div className="fixed inset-0 bg-black/30" aria-hidden="true" />;
}
